import { field, hidden } from "@/utils/models/decorator-field";
import { model } from "@/utils/models/decorator-model";
import SizeTableEntry from "./size-table-entry";

@model("ProductSizeBarcode")
export class ProductSizeBarcode {
	@field("number")
	@hidden()
	public ProductID:number = 0;

	@field("number")
	@hidden()
	public SizeTableEntryID:number = 0;

	@field("string")
	public Barcode:string = "";

	@field("has-one", "SizeTableEntry")
	public SizeTableEntry:SizeTableEntry | null = null;

	public constructor(data?:any) {
		if (!data) return;
		this.ProductID = data.ProductID;
		this.SizeTableEntryID = data.SizeTableEntryID;
		this.Barcode = data.Barcode;
		this.SizeTableEntry = data.SizeTableEntry ? new SizeTableEntry(data.SizeTableEntry) : null;
	}

	public getJSON(this:ProductSizeBarcode) {
		return {
			ProductID: this.ProductID,
			SizeTableEntryID: this.SizeTableEntryID,
			Barcode: this.Barcode
		};
	}
}
